module.exports = __webpack_public_path__ + "static/media/downArrow.74d2ba62.svg";